export default function WorkflowStatCard({
  title,
  value,
  icon: Icon,
  gradient,
  iconBg
}) {
  return (
    <div
      className={`relative rounded-2xl p-6 border border-gray-200 overflow-hidden ${gradient}`}
    >
      <div
        className={`${iconBg} w-12 h-12 rounded-xl flex items-center justify-center mb-4`}
      >
        <Icon className="w-6 h-6 text-gray-700" />
      </div>
      <h3 className="text-gray-600 text-sm font-medium mb-2">{title}</h3>
      <p className="text-4xl font-bold text-gray-900">{value}</p>
    </div>
  );
}
